import React from "react";
import { connect } from 'react-redux'
import { Card, Row, Col, Button, notification } from 'antd'
import moment from "moment";
import Request from "../../request";

class Timer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            startTime: '',
            endTime: '',
            totalWorkDuration: '',
            hours: 0,
            minutes: 0,
            seconds: 0,
            stop: true,
            latitude: 0,
            longitude: 0,
            loginHistory: [],
            intervalId: '',
            activeUser: {},
            companyDetails: {}
        }
    }
    componentDidMount() {
        this.getLoginData();
        this.fetchLocation();
        this.getActiveUser();
    }
    getLoginData = async () => {
        let response = await Request.getLoginTime();
        if (response.success) {
            let lastLogin = response.lastLogin;
            if (lastLogin) {
                let loginTime = moment(lastLogin.loginAt, 'HH:mm:ss').format('HH:mm:ss')
                let currentTime = moment().format('HH:mm:ss');
                let diffTime = moment.utc(moment(currentTime, "HH:mm:ss").diff(moment(loginTime, "HH:mm:ss"))).format('HH:mm:ss')
                diffTime = diffTime.split(":")
                this.setState({ hours: Number(diffTime[0]), minutes: Number(diffTime[1]), seconds: Number(diffTime[2]), stop: false })
                if (!this.state.stop) {
                    var intervalId = setInterval(this.timerStart, 1000);
                    this.setState({ intervalId: intervalId });
                }
            }
            this.setState({ loginHistory: response.loginHistory });
        }
    }
    success = (position) => {
        let latitude = position.coords.latitude;
        let longitude = position.coords.longitude;
        this.setState({ latitude: latitude, longitude: longitude })
    }
    error = (err) => {
        // this.error(err)
    }

    fetchLocation = () => {
        navigator.geolocation.getCurrentPosition(this.success, this.error);
    }

    getActiveUser = async () => {
        let activeUser = JSON.parse(localStorage.getItem('user'))
        let companyDetails = await Request.getCompanySetting({ businessId: activeUser.businessId })
        this.setState({ activeUser: activeUser, companyDetails: companyDetails })
    }


    timerStart = async () => {
        let { seconds, minutes, hours } = this.state
        seconds += 1;
        if (seconds > 59) {
            minutes += 1;
            seconds = 0;
        }
        if (minutes > 59) {
            hours += 1;
            minutes = 0;
            seconds = 0;
        }
        this.setState({ seconds, minutes, hours });
    }

    async checkLoginLogoutTime() {
        let { shiftTiming } = this.state.activeUser
        let timing = shiftTiming.split(' - ');
        let shiftStartTime = moment(timing[0], "HH:mm:ss A");
        let shiftEndTime = moment(timing[1], 'HH:mm:ss A');
        return {
            shiftStartTime, shiftEndTime
        }
    }

    handleTimerStart = async () => {
        this.setState({ loading: true })
        let lateLoginReason
        let { activeUser, companyDetails } = this.state
        if (activeUser.shiftTiming && companyDetails.promptForEarlyLoginLogout) {
            let loginResponse = await this.checkLoginLogoutTime()
            let newShiftStartTime = loginResponse.shiftStartTime.add(5, 'minutes')
            if (moment() > newShiftStartTime) {
                lateLoginReason = prompt('Enter Reason For Late Login')
            }
        }

        let location = {
            latitude: this.state.latitude,
            longitude: this.state.longitude
        }

        if (lateLoginReason === null || lateLoginReason === "") {
            notification.error({
                message: 'Enter Reason For Late Login First'
            })
            this.setState({ stop: true, loading: false })
            return
        }
        let response = await Request.startTimer({ location, lateLoginReason, loginTime: moment() });
        if (response.error) {
            notification.error({
                message: response.message
            })
            this.setState({ stop: true, loading: false })
        } else {
            await this.getLoginData()
            localStorage.setItem("timerStartTime", moment().toISOString());
            this.setState({ stop: false, loading: false })
        }

    }

    handleTimerStop = async () => {
        this.setState({ loading: true })
        let earlyLogoutReason
        let { activeUser, companyDetails } = this.state
        if (activeUser.shiftTiming && companyDetails.promptForEarlyLoginLogout) {
            let loginResponse = await this.checkLoginLogoutTime()
            if (moment() < loginResponse.shiftEndTime) {
                earlyLogoutReason = prompt('Enter Reason For Early Logout First')
            }
        }
        if (earlyLogoutReason === null || earlyLogoutReason === "") {
            notification.error({
                message: 'Enter Reason For Early Logout'
            })
            this.setState({ loading: false })
            return
        }
        let response = await Request.stopTimer({ earlyLogoutReason, logoutTime: moment() })
        if (response.error) {
            notification.error({
                message: response.msg,
            })
            this.setState({ loading: false })
            return
        }
        await this.getLoginData()
        localStorage.removeItem("timerStartTime");
        clearInterval(this.state.intervalId);
        this.setState({ stop: true, minutes: 0, seconds: 0, hours: 0, loading: false })
        clearInterval(this.state.intervalId);
    }

    render() {
        const { loginHistory, hours, minutes, seconds, stop } = this.state;
        return (
            <Card title="Time" style={{ textAlign: "center" }} >
                <Row>
                    <Col span={20}>
                        <div className="clock-container">
                            <div className="clock-col">
                                <p className="clock-day clock-timer">
                                    {moment().format('dd')}
                                </p>
                                <p className="clock-label">
                                    Day
                                </p>
                            </div>
                            <div className="clock-col">
                                <p className="clock-hours clock-timer">
                                    {hours < 10 ? "0" + hours : hours}
                                </p>
                                <p className="clock-label">
                                    Hours
                                </p>
                            </div>
                            <div className="clock-col">
                                <p className="clock-minutes clock-timer">
                                    {minutes < 10 ? "0" + minutes : minutes}
                                </p>
                                <p className="clock-label">
                                    Minutes
                                </p>
                            </div>
                            <div className="clock-col">
                                <p className="clock-seconds clock-timer">
                                    {seconds < 10 ? "0" + seconds : seconds}
                                </p>
                                <p className="clock-label">
                                    Seconds
                                </p>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        {
                            stop ?
                                <Button loading={this.state.loading} style={{ backgroundColor: '#2C6E49', color: '#fff', padding: '45px 25px', borderRadius: '5px', marginLeft: '5px', display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }} onClick={this.handleTimerStart.bind(this)}>{this.state.loading ? 'Starting...' : 'Start'}</Button>
                                :
                                <Button loading={this.state.loading} style={{ backgroundColor: '#E86310', color: '#fff', padding: '45px 25px', borderRadius: '5px', marginLeft: '5px', display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }} onClick={this.handleTimerStop.bind(this)}>{this.state.loading ? 'Stoping...' : 'Stop'}</Button>
                        }
                    </Col>
                </Row>
                <table width={"100%"}>
                    <tbody>
                        <tr>
                            <th>Login At</th>
                            <th>Logout At</th>
                            <th>Working Hours</th>
                        </tr>
                        {
                            loginHistory && loginHistory.map((history, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{history.loginAt}</td>
                                        <td>{history.logoutAt}</td>
                                        <td>{history.workingHours}</td>
                                    </tr>
                                )
                            })
                        }

                    </tbody>
                </table>
            </Card>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Timer)